import PropertyDocumentsContainer from 'app/sm/property_documents/property_documents_container'

export default PropertyDocumentsContainer
